import { fetchListById, fetchListBySlug, fetchListsById } from './http/ListHttp';
import { ListModel } from './models/ListModel';
import {
    normalizeHomepageLists,
    normalizeList,
    normalizeLists,
    normalizePartialArticleList,
} from './normalizers/ListNormalizer';

export const getListBySlug = async (slug: string): Promise<ListModel | null> => {
    const response = await fetchListBySlug(slug);

    if (response && Array.isArray(response)) {
        return normalizePartialArticleList(response[0]);
    }
    return null;
};

export const removeInactiveContentInList = (list: ListModel | null): ListModel | null => {
    if (list && list.items) {
        list.items = list.items.filter((item) => item && item.status === 'active');
        return list;
    }

    return list;
};

export const getHomepageListsById = async (listIds: string[]) => {
    const response = await fetchListsById(listIds);
    return normalizeHomepageLists(response);
};

export const getListsById = async (listIds: string[]): Promise<ListModel[]> => {
    const response = await fetchListsById(listIds);
    return normalizeLists(response);
};

export const getListById = async (id: string = ''): Promise<ListModel | null> => {
    try {
        const response = await fetchListById(id);
        return normalizeList(response);
    } catch (e) {
        console.error('Error retrieving list by id: ', e);
        return null;
    }
};
